/* eslint-disable arrow-body-style */
import { deleteBookItem } from '../actionCreators';

const deleteBook = bookId => {
  return async dispatch => {
    await fetch(`http://localhost:9000/books/${bookId}`, {
      method: 'DELETE',
    });

    dispatch(deleteBookItem(bookId));
  };
};

export default deleteBook;
